var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57215 8.48521C7.76741 8.68047 8.084 8.68047 8.27926 8.48521C8.47452 8.28994 8.47452 7.97336 8.27926 7.7781L4.92 4.41884L8.27817 1.06066C8.47344 0.865397 8.47344 0.548814 8.27817 0.353552C8.08291 0.15829 7.76633 0.15829 7.57107 0.353552L4.21289 3.71173L0.854638 0.353478C0.659376 0.158216 0.342793 0.158216 0.147531 0.353478C-0.0477309 0.54874 -0.0477307 0.865323 0.147531 1.06058L3.50578 4.41884L0.146447 7.77817C-0.0488156 7.97344 -0.0488155 8.29002 0.146447 8.48528C0.341709 8.68054 0.658291 8.68054 0.853553 8.48528L4.21289 5.12594L7.57215 8.48521Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.49b6e9c2f7cbeec7174b3514cb40a8eb.svg";
export { ForwardRef as ReactComponent };